// ../base/config/index.ts
var ConfigBase = class {
  #config;
  constructor(config2) {
    this.#config = config2;
  }
  /**
   * Get a copy of the config object
   */
  get() {
    return { ...this.#config, ...JSON.parse(JSON.stringify(this.#config)) };
  }
  /**
   * Update configuration object by mutation
   *
   * Pass a function that receives a copy of the current config.
   * Any mutations to this copy will be applied as the new config object.
   *
   * @example
   * ```ts
   * config.set((existingConfig) => {
   *   existingConfig.someProp = 1234;
   *   existingConfig.nested.prop = 'abcd';
   * })
   * ```
   */
  set(updateConfig) {
    const configCopy = this.get();
    updateConfig(configCopy);
    Object.assign(this.#config, configCopy);
  }
};

// src/config/index.ts
var config = new ConfigBase({
  auth: {
    autoRefresh: true,
    autoRefreshTime: 30 * 60 * 1e3,
    cookies: {
      token: "jw_auth_gateway",
      mfa: {
        identifier: "jw_auth_gateway_mfa",
        ttl: 60 * 60 * 24 * 14
        // 14 days
      },
      authFromAdmin: "jw_auth_gateway_from_admin"
    }
  },
  urls: {
    apiGateway: ""
  }
});

export { config };
